module.exports = __webpack_public_path__ + "static/img/logo_zm_zmxcl.377b05e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_zm_zmxcl.gif
// module id = /hR/
// module chunks = 1